import { ComponentProps, memo, ReactNode } from 'react'
import { Link as RouterLink } from '@tanstack/react-router'
import cn from 'classnames'

interface ILinkProps {
  children: ReactNode
  to: ComponentProps<typeof RouterLink>['to']
  className?: string
  inverse?: boolean
  isShowTargetIcon?: boolean
  onClick?: ComponentProps<typeof RouterLink>['onClick']
  rel?: string
  target?: '_self' | '_blank' | '_parent' | '_top'
  testId?: string
  title?: string
}

export const Link = ({ to, children, inverse, isShowTargetIcon, target, className, testId, ...props }: ILinkProps) => {
  const isBlank = target === '_blank'

  return (
    <RouterLink
      data-test-id={testId}
      rel={isBlank ? 'noopener noreferrer' : undefined}
      target={target}
      className={cn(
        inverse ? 'link-inverse' : 'link',
        'cursor-pointer',
        !isShowTargetIcon && 'after:hidden',
        'focus:z-10 focus:rounded-sm focus:border-primary focus:ring-md focus:ring-primary/focused',
        className
      )}
      {...props}
      to={to}
    >
      {children}
    </RouterLink>
  )
}

export default memo(Link)
